import { render, staticRenderFns } from "./Pillar3.vue?vue&type=template&id=4f831c2d&"
import script from "./Pillar3.vue?vue&type=script&lang=js&"
export * from "./Pillar3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports